export function splitBulkDiscounts(discounts = []) {
  if (!discounts) {
    return {
      subtotalDiscounts: [],
      variantDiscounts: [],
      ticketTypeDiscounts: [],
    };
  }

  return discounts.reduce(
    (acc, discount) => {
      if (discount.quantityCondition === 'variantOptionQuantity') {
        acc.variantDiscounts.push(discount);
      } else if (discount.quantityCondition === 'ticketTypeQuantity') {
        acc.ticketTypeDiscounts.push(discount);
      } else if (
        discount.quantityCondition === 'checkoutQuantity' ||
        discount.quantityCondition === 'totalQuantity'
      ) {
        acc.subtotalDiscounts.push(discount);
      }

      return acc;
    },
    { subtotalDiscounts: [], variantDiscounts: [], ticketTypeDiscounts: [] },
  );
}
